import React from 'react';
import { MainLayout } from '../layouts/MainLayout';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { Plus, FileText, Send, Printer } from 'lucide-react';
interface QuoteBuilderProps {
  onLogout: () => void;
}
export function QuoteBuilder({
  onLogout
}: QuoteBuilderProps) {
  return <MainLayout title="Angebotserstellung" onLogout={onLogout} data-id="element-562">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-563">
        {/* Left: Package Selection */}
        <div className="lg:col-span-2 space-y-6" data-id="element-564">
          <Card title="Hardware & Services Packages" data-id="element-565">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-566">
              <div className="border border-slate-200 rounded-lg p-4 hover:border-teal-500 cursor-pointer transition-colors" data-id="element-567">
                <div className="flex justify-between items-start mb-2" data-id="element-568">
                  <h3 className="font-semibold text-slate-900" data-id="element-569">
                    Standard Arbeitsplatz
                  </h3>
                  <Badge variant="secondary" data-id="element-570">Hardware</Badge>
                </div>
                <p className="text-sm text-slate-500 mb-4" data-id="element-571">
                  Dell Latitude 5520, Docking Station, 2x 24" Monitor,
                  Maus/Tastatur
                </p>
                <div className="flex justify-between items-center" data-id="element-572">
                  <span className="font-bold text-slate-900" data-id="element-573">€ 1.499,00</span>
                  <Button size="sm" variant="outline" leftIcon={<Plus className="h-3 w-3" data-id="element-575" />} data-id="element-574">
                    Hinzufügen
                  </Button>
                </div>
              </div>

              <div className="border border-slate-200 rounded-lg p-4 hover:border-teal-500 cursor-pointer transition-colors" data-id="element-576">
                <div className="flex justify-between items-start mb-2" data-id="element-577">
                  <h3 className="font-semibold text-slate-900" data-id="element-578">
                    Managed Antivirus
                  </h3>
                  <Badge variant="info" data-id="element-579">Service</Badge>
                </div>
                <p className="text-sm text-slate-500 mb-4" data-id="element-580">
                  SentinelOne Endpoint Protection, 24/7 Monitoring, Monatlich
                  pro Client
                </p>
                <div className="flex justify-between items-center" data-id="element-581">
                  <span className="font-bold text-slate-900" data-id="element-582">€ 4,50 / M</span>
                  <Button size="sm" variant="outline" leftIcon={<Plus className="h-3 w-3" data-id="element-584" />} data-id="element-583">
                    Hinzufügen
                  </Button>
                </div>
              </div>

              <div className="border border-slate-200 rounded-lg p-4 hover:border-teal-500 cursor-pointer transition-colors" data-id="element-585">
                <div className="flex justify-between items-start mb-2" data-id="element-586">
                  <h3 className="font-semibold text-slate-900" data-id="element-587">
                    M365 Business Standard
                  </h3>
                  <Badge variant="info" data-id="element-588">Lizenz</Badge>
                </div>
                <p className="text-sm text-slate-500 mb-4" data-id="element-589">
                  Office Apps, Exchange, Teams, SharePoint. Monatlich pro User.
                </p>
                <div className="flex justify-between items-center" data-id="element-590">
                  <span className="font-bold text-slate-900" data-id="element-591">€ 12,80 / M</span>
                  <Button size="sm" variant="outline" leftIcon={<Plus className="h-3 w-3" data-id="element-593" />} data-id="element-592">
                    Hinzufügen
                  </Button>
                </div>
              </div>

              <div className="border border-slate-200 rounded-lg p-4 hover:border-teal-500 cursor-pointer transition-colors" data-id="element-594">
                <div className="flex justify-between items-start mb-2" data-id="element-595">
                  <h3 className="font-semibold text-slate-900" data-id="element-596">
                    Einrichtungspauschale
                  </h3>
                  <Badge variant="warning" data-id="element-597">Dienstleistung</Badge>
                </div>
                <p className="text-sm text-slate-500 mb-4" data-id="element-598">
                  Installation, Konfiguration, Einbindung ins Netzwerk (ca. 2
                  Std)
                </p>
                <div className="flex justify-between items-center" data-id="element-599">
                  <span className="font-bold text-slate-900" data-id="element-600">€ 190,00</span>
                  <Button size="sm" variant="outline" leftIcon={<Plus className="h-3 w-3" data-id="element-602" />} data-id="element-601">
                    Hinzufügen
                  </Button>
                </div>
              </div>
            </div>
          </Card>
        </div>

        {/* Right: Quote Preview */}
        <div className="lg:col-span-1" data-id="element-603">
          <Card title="Aktuelles Angebot" className="h-full flex flex-col" data-id="element-604">
            <div className="flex-1" data-id="element-605">
              <div className="mb-4 pb-4 border-b border-slate-100" data-id="element-606">
                <h4 className="text-sm font-medium text-slate-500" data-id="element-607">Kunde</h4>
                <p className="font-semibold text-slate-900" data-id="element-608">Müller GmbH</p>
              </div>

              <div className="space-y-3 mb-6" data-id="element-609">
                <div className="flex justify-between text-sm" data-id="element-610">
                  <span data-id="element-611">1x Standard Arbeitsplatz</span>
                  <span className="font-medium" data-id="element-612">1.499,00 €</span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-613">
                  <span data-id="element-614">1x Einrichtungspauschale</span>
                  <span className="font-medium" data-id="element-615">190,00 €</span>
                </div>
                <div className="flex justify-between text-sm text-slate-500 pt-2 border-t border-slate-100" data-id="element-616">
                  <span data-id="element-617">Zwischensumme</span>
                  <span data-id="element-618">1.689,00 €</span>
                </div>
                <div className="flex justify-between text-sm text-slate-500" data-id="element-619">
                  <span data-id="element-620">MwSt. (19%)</span>
                  <span data-id="element-621">320,91 €</span>
                </div>
                <div className="flex justify-between text-lg font-bold text-slate-900 pt-2 border-t border-slate-200" data-id="element-622">
                  <span data-id="element-623">Gesamt</span>
                  <span data-id="element-624">2.009,91 €</span>
                </div>
              </div>
            </div>

            <div className="space-y-2 mt-auto" data-id="element-625">
              <Button className="w-full" leftIcon={<Send className="h-4 w-4" data-id="element-627" />} data-id="element-626">
                Angebot versenden
              </Button>
              <Button variant="secondary" className="w-full" leftIcon={<Printer className="h-4 w-4" data-id="element-629" />} data-id="element-628">
                PDF Vorschau
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </MainLayout>;
}